import React from "react";
import {useNavigate} from "react-router-dom";
import {Init} from "../workspace/init";

export default function WorkspaceCreate() {
    const navigate = useNavigate();
    const close = () => navigate("/");

    return <Init closable onClose={close} onCreated={close}/>;
}
